export default {
  toasts: {
    load_error: 'Ratele comisioanelor nu au putut fi încărcate',
    failed_to_save_changes: 'Modificările nu au putut fi salvate',
    changes_got_saved: 'Modificări salvate',
  },
  buttons: {
    edit: 'Editare',
    cancel: 'Anulare',
    save: 'Salvare',
  },
  rates: {
    title: 'Marjă de procesare',
    description:
      'Procent în %, plus o sumă fixă și una minimă opționale per tranzacție. „Orice metodă de plată” se aplică dacă nu există o rată specifică metodei.',
  },
};
